<template>
  <div>
    <div class="toolbar">
      <el-input v-model="searchId" placeholder="ID" style="width:70px;margin-right: 8px;"/>
      <el-input v-model="search" placeholder="输入关键字搜索" style="width:400px;margin-right:8px;" clearable/>
      <el-button type="primary" @click="handleAdd">添加</el-button>
    </div>
    <el-table
        ref="multipleTable"
        :data="tableData"
        border
        style="width: 100%"
        @sort-change="handleSort"
    >
      <el-table-column prop="id" label="编号" sortable="custom" width="100"></el-table-column>
      <el-table-column label="预览">
        <template v-slot="column">
          <PinyinPreview class="pinyin-preview" :text="column.row.text" :pinyin="column.row.pinyin"></PinyinPreview>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click="showWords(scope.row)" type="text" size="small">分词</el-button>
          <el-button @click="showTrans(scope.row)" type="text" size="small">翻译</el-button>
          <el-button @click="updateForm(scope.row)" type="text" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        v-if="total>pageSize"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="400">
      <SentenceForm ref="form"></SentenceForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分词管理" :visible.sync="showWordDialog" width="80%">
      <SentenceWord ref="word" :model="showWordModel"></SentenceWord>
    </el-dialog>
    <ModelTranslation ref="trans" type="sentence"></ModelTranslation>
  </div>
</template>

<script>
import table from '@/components/mixins/table.js'
import SentenceForm from './SentenceForm'
import PinyinPreview from '@/components/PinyinPreview'
import SentenceWord from '@/views/sentence/SentenceWord'
import ModelTranslation from "@/views/locale/ModelTranslations.vue";

export default {
  name: 'AiImageSentenceList',
  mixins: [table],
  data() {
    return {
      dialogTitle: '添加句子',
      dialogVisible: false,
      batchVisible: false,
      fetchUrl: 'sentence_list',
      search: '',
      searchId: null,
      searchType: null,
      showWordDialog: false,
      showWordModel: null
    }
  },
  components: {ModelTranslation, SentenceForm, PinyinPreview, SentenceWord},
  watch: {
    search() {
      this.fetchData()
    },
    searchId() {
      this.fetchData()
    },
    searchType() {
      this.fetchData()
    },
  },
  methods: {
    handleFetchConfig(config) {
      Object.assign(config.params, {
        "filter[status]": null,
        "filter[and][0][id]": this.searchId || null,
        "filter[and][0][status]": 1,
        "filter[and][0][course_id]": 5,
        "filter[and][0][ref_type]": this.searchType || null,
        "filter[and][1][or][0][text][like]": this.search || null,
        "filter[and][1][or][1][pinyin][like]": this.search || null
      })
    },
    createForm() {
      this.dialogVisible = true
      this.dialogTitle = '添加句子'
      setTimeout(() => {
        if (this.$refs.form.id) {
          this.$refs.form.initData({})
        }
      }, 1)
    },
    submitForm() {
      this.$refs.form.submit().then(res => {
        this.dialogVisible = false
        this.fetchData()
        this.$refs.form.initData({})
      })
    },
    updateForm(item) {
      this.dialogVisible = true
      this.dialogTitle = '编辑句子'
      setTimeout(() => {
        this.$refs.form.initData(item)
      }, 10)
    },
    showWords(item) {
      this.showWordModel = item
      this.showWordDialog = true
    },
    handleAdd() {
      this.dialogVisible = true
      this.dialogTitle = '添加句子'
      setTimeout(() => {
        this.$refs.form.initData({})
      }, 10)
    },
    handleCopy(item) {
      this.dialogVisible = true
      this.dialogTitle = '复制句子'
      setTimeout(() => {
        this.$refs.form.initData(Object.assign({}, item, {id: 0}))
      }, 10)
    },
    showTrans(item) {
      this.$refs.trans.show(item.id, {
        title: `翻译: ${item.id}`,
        originText: item.text,
      });
    }
  }
}
</script>